import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "ec-1858be3a-2a7c-4fbb-b9c0-febc976657ba-__Layer_1",
  "enable-background": "new 0 0 72 72",
  height: "512",
  viewBox: "0 0 72 72",
  width: "512",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g id=\"ec-850850a9-efb3-4e23-8be8-59adfceceabd-__Layer_2_1_\"><g id=\"ec-cedf7cf9-aa80-43c9-a76f-47f5fc8a5915-__Layer_1-2\"><g id=\"ec-80b67469-b72d-4c5e-9704-4b1583b47346-__format_align_center\"><path d=\"m63 15h-54c-1.7 0-3-1.3-3-3s1.3-3 3-3h54c1.7 0 3 1.3 3 3s-1.3 3-3 3z\"></path><path d=\"m54 31h-36c-1.7 0-3-1.3-3-3s1.3-3 3-3h36c1.7 0 3 1.3 3 3s-1.3 3-3 3z\"></path><path d=\"m63 47h-54c-1.7 0-3-1.3-3-3s1.3-3 3-3h54c1.7 0 3 1.3 3 3s-1.3 3-3 3z\"></path><path d=\"m54 63h-36c-1.7 0-3-1.3-3-3s1.3-3 3-3h36c1.7 0 3 1.3 3 3s-1.3 3-3 3z\"></path></g></g></g>", 1)
  ]))]))
}
export default { render: render }